(function () {
  'use strict';

  var MAX_CHARS = 450;

  function init() {
    document.querySelectorAll('[data-wand-desc]').forEach(function (desc) {
      // Check plain-text length (no HTML tags) — never cuts mid-tag
      var textLen = (desc.textContent || '').trim().length;
      if (textLen <= MAX_CHARS) return;

      var wrap = desc.parentElement;
      var btn = wrap && wrap.querySelector('.wand-desc-toggle');
      if (!btn) return;

      // Apply collapsed state
      desc.classList.add('wand-desc--collapsed');

      // Show the toggle button
      btn.removeAttribute('hidden');

      btn.addEventListener('click', function () {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          // Collapse: set explicit height before collapsing so transition is smooth
          desc.style.maxHeight = desc.scrollHeight + 'px';
          // Force reflow
          desc.offsetHeight; // eslint-disable-line no-unused-expressions
          desc.classList.add('wand-desc--collapsed');
          desc.style.maxHeight = '';
        } else {
          // Expand: measure full height, animate to it, then remove constraint
          var fullH = desc.scrollHeight;
          desc.style.maxHeight = fullH + 'px';
          desc.classList.remove('wand-desc--collapsed');
          desc.addEventListener('transitionend', function onEnd() {
            desc.style.maxHeight = '';
            desc.removeEventListener('transitionend', onEnd);
          });
        }

        btn.setAttribute('aria-expanded', String(!isExpanded));
        var label = btn.querySelector('.wand-desc-toggle__label');
        // Labels are localized in Liquid and passed via data attributes
        // (data-label-more / data-label-less). Fall back to English if absent.
        var moreLabel = btn.getAttribute('data-label-more') || 'Show more';
        var lessLabel = btn.getAttribute('data-label-less') || 'Show less';
        if (label) label.textContent = isExpanded ? moreLabel : lessLabel;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
